// extracted by mini-css-extract-plugin
module.exports = {"textTitle":"SectionTitle_textTitle__oldWk","textSubTitle":"SectionTitle_textSubTitle__NHin5"};